<div class="alert alert-info" ng-show="vm.files.length == 0">Keine Daten gefunden</div>

<!--table-->
<!-- Must use ng-if to display, ng-show will not render automatically, only after resize -->
<div class="gridStyle fileGrid" ui-grid="vm.gridOptions" ng-if="vm.files.length > 0"></div>
<div class="comfortspace">&nbsp;</div>

<!-- template for tags cell -->
<script type="text/ng-template" id="filetagtemplate">
    <tags-input ng-model="row.entity.keywords"
                display-property="text"
                id="filekeywords{{$index}}"
                add-on-paste="true"
                add-on-comma="false"
                add-on-enter="true"
                min-length="1"
                ng-blur="grid.appScope.vm.saveFile(row.entity)"
                enable-editing-last-tag="true"
                add-from-autocomplete-only="false"
                replace-spaces-with-dashes="false"
                template="filetag-template">
        <auto-complete source="grid.appScope.vm.getTags($query)"
                       min-length="1"
                       load-on-focus="true"
                       load-on-empty="false"
                       load-on-down-arrow="true"
                       max-results-to-show="32"
                       select-first-match="true"
                       template="filetagautocomplete-template">
        </auto-complete>
    </tags-input>
</script>


<!--template for action buttons-->
<script type="text/ng-template" id="fileactiontemplate">
    <div class="ui-grid-cell-contents">
    <span style="text-align: right">
        <a href="/routes/files/filereader/{{row.entity.fileid}}" target="_blank" class="btn btn-primary btn-xs"><i
            class="fa fa-eye"></i></a>
        <a href="/routes/files/filedownload/{{row.entity.fileid}}" class="btn btn-primary btn-xs"><i
            class="fa fa-download"></i></a>
        <!-- delete file, mit Rückfrage -->
        <a ng-really-click="grid.appScope.vm.removeFile(row.entity, $index)"
           ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?"
           class="btn btn-danger btn-xs">
            <i class="fa fa-remove"></i>
        </a>
        <!-- unlink file, mit Rückfrage -->
        <a ng-really-click="grid.appScope.vm.unlinkFile(row.entity)"
           ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"
           class="btn btn-warning btn-xs">
            <i class="fa fa-unlink"></i>
        </a><sprhelp tip="Dateizuordnung aufheben" descref="grid.appScope.vm.helpunlink"></sprhelp>
        <!-- TODO: is there really not better way to access the help content? -->
      </span>
    </div>
</script>

<!-- tag template -->
<script type="text/ng-template" id="filetag-template">
    <div class="tag-template" style="z-index: 10000">
        <div class="right-panel">
            <span>{{$getDisplayText()}}</span>
            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
        </div>
    </div>
</script>

<!-- tag autocomplete template -->
<script type="text/ng-template" id="filetagautocomplete-template">
    <div class="filetagautocomplete-template" style="z-index: 10000">
        <div>
            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>
        </div>
    </div>
</script>